import React, { Component } from 'react'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import moment from 'moment'
import 'moment/min/locales'
import {FormattedMessage, injectIntl} from 'react-intl';

class TicketItems extends Component {
	constructor(props) {
    super(props);
    this.props = props;

    this.ajaxHandler = new AjaxHandler();

    moment.locale('es');

    if(props.ticket) {
      this.ticket = props.ticket;
    }


    this.state = {
      loading: false,
      items: [],
      itemsCierre: []
    }
  }

  componentDidMount(nextProps, nextState) {
    if(Security.hasPermission('TICKETS_VER_TAREAS')) {
        this.ajaxHandler.subscribe(this);
        this.loadFormData();
    } else {
      this.setState({
        redirectTo: '/error'
      });
    }
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  loadFormData() {
    this.ajaxHandler.getJson('/items/ticket-has-items-cierre/' + this.ticket.id)
    .then(hasItemsCierre => {
      let component = this;
      // let grid = ConfigBusiness.get('tickets.tareasCierre.habilitado') === 'true' ? ( hasTareasCierre ? '/gridCierre' : '/grid' ) : '/grid';
      let gridCierre = hasItemsCierre ? '/gridCierre' : '/grid';
      this.setState({ loading: true });
      return new Promise((resolve, reject)=>{
        Promise.all([
      this.ajaxHandler.getJson('/items/ticket/' + this.ticket.id + '/grid' ),
      this.ajaxHandler.getJson('/items/ticket/' + this.ticket.id + gridCierre )

        ]).then(data => {
        if(data) component.setState({
          items: data[0],
          itemsCierre: data[1]
        });
      })
      .catch(function(error) {
        component.ajaxHandler.handleError(error);
        reject();
    }).finally(() => {
      component.setState({ loading: false });
      resolve();
    });
  });
  });
  }

	render() {
    if(this.ticket) {
      // Determinar si usar items de cierre según configuraciones (global o con abono)
      let usarItemsCierre = ConfigBusiness.get('tickets.tareasCierre.habilitado') === 'true';
      let usarItemsCierreConAbono = false;
      if (!usarItemsCierre && ConfigBusiness.get('tickets.conAbono.tareasCierre.habilitado') === 'true') {
        usarItemsCierreConAbono = this.props.ticket.abono === true;
        usarItemsCierre = usarItemsCierreConAbono;
      }
      
      // Mostrar montos SOLO si es config global Y montosRepuesto está habilitado
      // Si es config de abono, NO mostrar montos (funciona como montosRepuesto en false)
      let mostrarMontos = !usarItemsCierreConAbono && ConfigBusiness.get('tickets.tareasCierre.montosRepuesto') === 'true';
      
      return (
        <React.Fragment>
          {this.state.loading && <Loading />}
          {this.state.items ? (
            <div className="card pull-up">
              <div className="card-content">
              { usarItemsCierre && (this.props.ticket.estado === 'CONFIRMAR_REPARACION' || this.props.ticket.estado === 'LISTO_PARA_RETIRAR' || this.props.ticket.estado === 'CERRADO'  ) ? (
                <div className="card-body">
                  <h4 className="form-section">
                  <i className="la la-tasks"></i><FormattedMessage id="ticketItems.render.task.header_items_cierre" defaultMessage=" Repuestos Realizados (Cierre)"/>
                  </h4>
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table">
                        <thead className="thead-fleet">
                          <tr>
                            <th scope="col"><FormattedMessage id="ticketItems.render.task.table_column_servicio" defaultMessage="Servicio"/></th>
                            <th scope="col"><FormattedMessage id="ticketItems.render.task.table_column_items" defaultMessage="Repuestos"/></th>
                            { mostrarMontos ? (<th scope="col"><FormattedMessage id="ticketItems.render.task.table_column_monto_total" defaultMessage="Monto Total"/></th>) :''}
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.itemsCierre.map((itemCierre, index)=>{
                          return(
                            <tr key={index}>
                              <td className="align-middle">{itemCierre.servicio.nombre}</td>
                              <td className="align-middle">{itemCierre.nombre}</td>
                              { mostrarMontos ? (<td className="align-middle">{itemCierre.montoTotal}</td>) :''}
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> 
                ) : ''}

                <div className="card-body">
                  <h4 className="form-section">
                   <i className="la la-tasks"></i><FormattedMessage id="ticketItems.render.task.header_items_apertura" defaultMessage=" Repuestos indicados al momento de apertura del Ticket"/>
                  </h4>
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table">
                        <thead className="thead-fleet">
                          <tr>
                            <th scope="col"><FormattedMessage id="ticketItems.render.task.table_column_servicio" defaultMessage="Servicio"/></th>
                            <th scope="col"><FormattedMessage id="ticketItems.render.task.table_column_items" defaultMessage="Repuestos"/></th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.state.items.map((item, index)=>{
                          return(
                            <tr key={index}>
                              <td className="align-middle">{item.servicio.nombre}</td>
                              <td className="align-middle">{item.nombre}</td>
                            </tr>
                          );
                        })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : ( null )}
        </React.Fragment>
      )
    } else {
      return null;
    }
  }
}

export default injectIntl(TicketItems);